import { AssignedWireType } from '@/types/wireTypes';
import { ApiResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export const getWireApi = async (wireId: string): Promise<ApiResponseType<AssignedWireType>> => {
  const uri = `/organization/wires/${wireId}/`;

  return authApiService.GET(uri);
};
